module.exports = __webpack_public_path__ + "img/etermax.74362dad.svg";